import React from 'react';
import { useDarkClasses } from '../../hooks/useDarkClasses';
import { ToggleSwitch } from './ToggleSwitch';
interface NotificationField {
  id: string;
  name: string;
  checked: boolean;
  label: string;
}
interface NotificationGroup {
  key: string;
  label: string;
  fields: NotificationField[];
}
interface NotificationToggleGroupProps {
  groups: NotificationGroup[];
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}
export const NotificationToggleGroup: React.FC<NotificationToggleGroupProps> = ({
  groups,
  onChange
}) => {
  const dk = useDarkClasses();
  return <div className="space-y-8" data-id="element-600" data-mp="tlrwy7d85w92">
      {groups.map(({
      key,
      label,
      fields
    }, groupIdx) => <div key={key} className={groupIdx > 0 ? `border-t pt-8 ${dk.border}` : ''} data-id="element-601" data-mp="omotgrcw7y37" data-mpi={groupIdx}>
          <h4 className={`text-sm font-semibold mb-4 ${dk.textHeading}`} data-id="element-602" data-mp="250ouk5nh5ts1">
            {label}
          </h4>
          <div className={`rounded-lg border overflow-hidden ${dk.border}`} data-id="element-603" data-mp="202dkpux6jj9t">
            {fields.map((field, i) => <div key={field.id} className={`flex items-center justify-between px-4 py-3.5 ${i > 0 ? `border-t ${dk.border}` : ''} ${dk.surfaceMuted}`} data-id="element-604" data-mp="mfn02lpgxxop" data-mpi={i}>
                <label htmlFor={field.id} className={`text-sm ${dk.textSecondary} cursor-pointer`} data-id="element-605" data-mp="wfxf8bv2df6i">
                  {field.label}
                </label>
                <ToggleSwitch id={field.id} name={field.name} checked={field.checked} onChange={onChange} data-id="element-606" data-mp="3ri1dsno52wr" />
              </div>)}
          </div>
        </div>)}
    </div>;
};